import React, { FC } from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import ArrowDown from '@pixel/assets/icons/SortDown'
import TextField from '@pixel/core/TextField'
import { styled } from '@pixel/core/styles'
import LocalizedTypography from '../../components/LocalizedTypography'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'
import {useMultipleLocalizedText} from '../../contexts/Localization/localizationHooks'
import Typography from "@pixel/core/Typography";
import {FieldListSearchResult} from "../types/FieldList";
import {Box} from "@pixel/core";


const ViewSectionContainer = styled('div')(({ theme }) => ({
    backgroundColor: 'white',
    borderRadius: '8px',
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
}))

const FieldListViewContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
})

const ViewHeaderSection = styled('div')(({ theme }) => ({
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(3),
}))

const ViewBodySection = styled('div')({
    backgroundColor: '#e4edf3',
    flexGrow: 1,
})

const ArrowDisplay = styled(ArrowDown)(({ theme }) => ({
    width: '100%',
    marginTop: theme.spacing(3),
}))

interface FieldListViewProps {
    selectedFieldList: FieldListSearchResult
}

const FieldListView: FC<FieldListViewProps> = ({
    selectedFieldList
 }) => {
    const {
        FIELD_LIST_FORM_NAME,
    } = useMultipleLocalizedText()

    const { control } = useFormContext()

    return (
        <FieldListViewContainer>
            <ViewHeaderSection>
                <Controller
                    control={control}
                    name="name"
                    rules={{ maxLength: 100, required: true, }}
                    render={() => (
                        <TextField
                            id="fieldListView-name"
                            defaultValue={selectedFieldList.name}
                            disabled
                            label={FIELD_LIST_FORM_NAME}
                            fullWidth
                            sx={{ marginBottom: 1 }}
                        />
                    )}
                />
            </ViewHeaderSection>
            <ViewBodySection>

                <ArrowDisplay />

                <ViewSectionContainer>
                    <LocalizedTypography
                        variant="h3"
                        text={LocalizedText.FIELD_LIST_VALUES}
                    />
                    {selectedFieldList.fieldListValues.map((field, index) => (
                        <Box key={index}  display="flex" alignItems="center">
                            <Typography data-id={`fieldListView-${field.value}-value`} variant="body1">{field.value}</Typography>
                        </Box>
                    ))}
                </ViewSectionContainer>

            </ViewBodySection>
        </FieldListViewContainer>
    )
}

export default FieldListView
